export default function(){

    const format = (number_pence, abbreviate, currencySymbol) => {
        let priceVal = number_pence / 100.0;
        if (abbreviate) {
            if (priceVal >= 1000000) {
                priceVal = number_format(priceVal / 1000000, 1) + 'M';
            } else if (priceVal >= 1000) {
                priceVal = number_format(priceVal / 1000, 1) + 'K';
            } else if (priceVal >= 100) {
                priceVal = number_format(priceVal, 0);
            } else {
                if (priceVal % 1 == 0) {
                    // Whole number, don't show decimal places
                    priceVal = priceVal ? number_format(priceVal, 0) : 0;
                } else {
                    // Finally, format any other number to 2 dp
                    priceVal = priceVal ? number_format(priceVal, 2) : 0;
                }
            }
        } else {
            priceVal = number_format(priceVal, 2);
        }
        return "" + currencySymbol + priceVal;
    };

    const number_format = (number, decimals, decPoint, thousandsSep) => {
        decimals = Math.abs(decimals) || 0;
        number = parseFloat(number);

        if (isNaN(number)) {
            return NaN;
        }

        if (!decPoint || !thousandsSep) {
            decPoint = '.';
            thousandsSep = ',';
        }

        let roundedNumber = Math.round(Math.abs(number) * ('1e' + decimals)) + '';
        let numbersString = decimals ? (roundedNumber.slice(0, decimals * -1) || 0) : roundedNumber;
        let decimalsString = decimals ? roundedNumber.slice(decimals * -1) : '';
        let formattedNumber = "";

        while (numbersString.length > 3) {
            formattedNumber += thousandsSep + numbersString.slice(-3);
            numbersString = numbersString.slice(0, -3);
        }

        if (decimals && decimalsString.length === 1) {
            while (decimalsString.length < decimals) {
                decimalsString = decimalsString + decimalsString;
            }
        }

        return (number < 0 ? '-' : '') + numbersString + formattedNumber + (decimalsString ? (decPoint + decimalsString) : '');
    };

    return {
        format,
        number_format
    };

};
